const { getOffsetTop } = window.BAO.Utils

class BaoParallax extends window.BAO.CustomElement() {
  static get styles () {
    return `
      :host {
        display: block;
      }
    `
  }

  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    const animationDuration = 10

    const windowHeight = window.innerHeight

    const elementHeight = this.offsetHeight
    if (elementHeight === 0) return

    const actualItemHeight = elementHeight + this.y
    const heightDifference = actualItemHeight - elementHeight

    const elementStartPoint = getOffsetTop(this) - windowHeight
    const elementEndPoint = getOffsetTop(this) + elementHeight

    if (this.lastKnownY < elementStartPoint) {
      setTimeout(() => {
        this.style.transform = `translate3d(${this.x}px, ${this.y /
          this.strength}px, 0px)`
      }, animationDuration)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      setTimeout(() => {
        this.style.transform = `translate3d(0px, ${this.y /
          -this.strength}px, 0px)`
      }, animationDuration)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      1 - (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2

    const transformAmountX = this.x * scrollYAsAPercentageOfJourney

    setTimeout(() => {
      this.style.transform = `translate3d(${transformAmountX}px, ${transformAmountY}px, 0px)`
    }, animationDuration)
  }

  get strength () {
    return this.dataset.strength
  }

  get x () {
    return parseFloat(this.dataset.distanceX) || 0
  }

  get y () {
    return parseFloat(this.dataset.distanceY) || 300
  }
}

if (!customElements.get('bao-parallax')) {
  customElements.define('bao-parallax', BaoParallax)
}
